import React, { useState } from 'react';

const Footer = () => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <button
        onClick={scrollToTop}
        className="fixed bottom-6 right-6 bg-orange hover:bg-orange text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-40"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </button>

      <a
        href="https://wa.me/919821015469"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-24 right-6 bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-40"
        title="Chat on WhatsApp"
      >
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </a>

      <footer className="bg-gray-700 text-white">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 text-white">ABOUT US</h3>
              <p className="text-white mb-4">
                United Marine Agency LLP provides professional maritime consulting services with vast experience in shipping, surveying and marine consultancy.
              </p>
              <p className="text-white mb-6">
                Recognized in India and overseas for diligence, personal reputation and professional experience.
              </p>
              <div className="flex gap-3">
                <a href="#" className="bg-orange hover:bg-orange w-10 h-10 rounded-full flex items-center justify-center transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                </a>
                <a href="#" className="bg-orange hover:bg-orange w-10 h-10 rounded-full flex items-center justify-center transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                  </svg>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-bold mb-4 text-white">
                QUICK LINKS
              </h3>

              <ul className="space-y-3">
                {[
                  { href: "#home", label: "Home" },
                  { href: "#about", label: "About Us" },
                  { href: "#services", label: "Services" },
                  { href: "#contact", label: "Contact Us" },
                ].map((item) => (
                  <li key={item.href}>
                    <a href={item.href} className="flex items-center">
                      
                      {/* Static Icon */}
                      <span className="mr-2 text-white">
                        ◆
                      </span>

                      {/* Hoverable Text Only */}
                      <span
                        className="
                          text-white
                          transition-all duration-300 ease-in-out
                          hover:text-orange
                          hover:translate-x-2
                          hover:font-semibold
                          hover:tracking-wide
                        "
                      >
                        {item.label}
                      </span>

                    </a>
                  </li>
                ))}
              </ul>
            </div>



            <div>
              <h3 className="text-xl font-bold mb-4 text-white">OUR SERVICES</h3>
              <ul className="space-y-2">
                <li className="text-white flex items-center">
                  <span className="text-white mr-2">◆</span> IMO Tank Container Certification
                </li>
                <li className="text-white flex items-center">
                  <span className="text-white mr-2">◆</span> Condition Survey Import/Export
                </li>
                <li className="text-white flex items-center">
                  <span className="text-white mr-2">◆</span> On/Off Hire Survey
                </li>
                <li className="text-white flex items-center">
                  <span className="text-white mr-2">◆</span> Pre/Post Repair Survey
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold mb-4 text-white">CONTACT INFO</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-white mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <div className="text-white">
                    <p className="font-bold">Head Office</p>
                    <p>E-104, Remi Bizcourt, Plot no. 9,</p>
                    <p>Shah Industrial Estate,</p>
                    <p>Off Veera Desai Road, Andheri West,</p>
                    <p>Mumbai - 400053</p>
                  </div>
                </div>
                <div className="flex">
                  <svg className="w-6 h-6 text-white mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <div className="text-white">
                    <p className="font-bold">Phone</p>
                    <p>+91 98210 15469</p>
                  </div>
                </div>
                <div className="flex">
                  <svg className="w-6 h-6 text-white mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <div className="text-white">
                    <p className="font-bold">Email</p>
                    <p>porusd@unitedllp.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 bg-gray-800">
          <div className="container mx-auto px-4 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-white text-sm mb-4 md:mb-0">
                © Copyright 2025 <span className="text-white font-semibold">United Marine Agency LLP</span>. All rights reserved.
              </p>
              <div className="flex gap-6 text-sm">
                <button onClick={() => setShowPrivacyModal(true)} className="text-white hover:text-white transition-colors">
                  Privacy Policy
                </button>
                <button onClick={() => setShowTermsModal(true)} className="text-white hover:text-white transition-colors">
                  Terms of Service
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {showPrivacyModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
              <h3 className="text-2xl font-bold text-gray-800">Privacy Policy</h3>
              <button onClick={() => setShowPrivacyModal(false)} className="text-gray-500 hover:text-gray-700">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="p-6 text-gray-700 space-y-4">
              <p className="font-semibold">Effective Date: January 1, 2025</p>
              <div>
                <h4 className="font-bold text-lg mb-2">1. Information Collection</h4>
                <p>We collect information necessary to provide marine consultancy and survey services, including contact details and shipment information.</p>
              </div>
              <div>
                <h4 className="font-bold text-lg mb-2">2. Data Usage</h4>
                <p>Your information is used solely for service delivery, communication, and improving our maritime consultancy services.</p>
              </div>
              <div>
                <h4 className="font-bold text-lg mb-2">3. Data Security</h4>
                <p>We implement appropriate security measures to protect your personal and business information.</p>
              </div>
              <div>
                <h4 className="font-bold text-lg mb-2">4. Contact</h4>
                <p>For questions about our Privacy Policy, contact us at porusd@unitedllp.com or call +91 98210 15469.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {showTermsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
              <h3 className="text-2xl font-bold text-gray-800">Terms of Service</h3>
              <button onClick={() => setShowTermsModal(false)} className="text-gray-500 hover:text-gray-700">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="p-6 text-gray-700 space-y-4">
              <p className="font-semibold">Effective Date: January 1, 2025</p>
              <div>
                <h4 className="font-bold text-lg mb-2">1. Service Agreement</h4>
                <p>By engaging United Marine Agency LLP services, you agree to these terms and conditions governing our professional maritime consultancy.</p>
              </div>
              <div>
                <h4 className="font-bold text-lg mb-2">2. Professional Standards</h4>
                <p>We maintain the highest standards of professional maritime consultancy and comply with all international regulations and best practices.</p>
              </div>
              <div>
                <h4 className="font-bold text-lg mb-2">3. Service Delivery</h4>
                <p>We commit to providing factual and flawless reporting through our expert marine consultants and surveyors.</p>
              </div>
              <div>
                <h4 className="font-bold text-lg mb-2">4. Limitation of Liability</h4>
                <p>Our liability is limited to the scope of services agreed upon in our consultancy contracts.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;